import throttle from 'lodash/throttle';

const headerAll = document.querySelectorAll('.js-header');
headerAll.forEach(header => {
	const scrollOffset = 80;
	let currentScroll;
	let prevScroll = window.scrollY || document.documentElement.scrollTop;
	let prevDirection = 0;
	let direction = 0;
	const limit = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight) - window.innerHeight;
	const checkScroll = () => {
		currentScroll = window.scrollY || document.documentElement.scrollTop;
		// Find the direction of scroll:
		// 0 - initial,
		// 1 - up,
		// 2 - down
		if (currentScroll > prevScroll) {
			direction = 2;
		} else if (currentScroll < prevScroll) {
			direction = 1;
		}
		// Secure bouncing out of window bottom at Safari
		if (currentScroll >= limit) {
			direction = 2;
		}
		if (direction !== prevDirection) {
			toggleHeader(direction, currentScroll);
		}
		if (currentScroll > 0) {
			header.classList.add('is-scrolled');
		} else {
			header.classList.remove('is-scrolled');
		}
		prevScroll = currentScroll;
	};
	const toggleHeader = (dir, curScroll) => {
		if (dir === 2 && curScroll > scrollOffset) {
			header.classList.add('is-scrolled-down');
			prevDirection = dir;
		} else if (dir === 1) {
			header.classList.remove('is-scrolled-down');
			prevDirection = dir;
		}
	};
	window.addEventListener('scroll', throttle(checkScroll, 100));
	window.addEventListener('load', checkScroll);
});


let menuItems = document.querySelectorAll('.js-header .menu-item-673, .js-header .menu-item-683');

if (menuItems) {
	menuItems.forEach(function(item) {
		item.addEventListener('mouseenter', function() {
			document.body.classList.add('is-submenu-visible');
		});

		item.addEventListener('mouseleave', function() {
			document.body.classList.remove('is-submenu-visible');
		});
	});
}


